import { alpha, hexToRgb, Theme } from "@mui/material";

export const additionalGlobalStylesProvider = (theme: Theme) => ({
  ".gm-style button:not(.MuiButtonBase-root)": {
    backgroundColor: `${alpha(
      hexToRgb(theme.palette.background.paper),
      1
    )} !important`,
    color: `${theme.palette.text.secondary} !important`,
  },
  ".gm-svpc": {
    backgroundColor: `${alpha(
      hexToRgb(theme.palette.background.paper),
      1
    )} !important`,
  },
  ".gm-style .gm-style-iw-c": {
    backgroundColor: alpha(hexToRgb(theme.palette.background.paper), 1),
    padding: "0 !important",
  },
  ".gm-style .gm-style-iw-d .gm-style-iw-d": {
    overflow: "hidden; !important",
  },
  ".gm-style-iw + div": {
    display: "none",
  },
  ".gm-ui-hover-effect > span": {
    backgroundColor: theme.palette.text.secondary,
  },
  ".gm-style .gm-style-iw-t::after": {
    backgroundColor: alpha(hexToRgb(theme.palette.background.paper), 0.8),
  },
  ".gm-style .gm-style-iw-d::-webkit-scrollbar": {
    display: "none",
  },
  ".gm-style .gm-style-iw-d::-webkit-scrollbar-track": {
    backgroundColor: alpha(hexToRgb(theme.palette.background.paper), 0.8),
  },
  ".gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece": {
    backgroundColor: alpha(hexToRgb(theme.palette.background.paper), 0.8),
  },
});
